import ShortlistCandidate from "./ShortlistCandidate";

export const candidateShortlist = [
  new ShortlistCandidate(
    "Alice",
    "Smith",
    "Software Engineer",
    "Google",
    "https://www.google.com/",
    "San Francisco, CA",
    "120000",
    "https://www.resume.com/alicesmith",
    "https://www.coverletter.com/alicesmith",
    "https://www.linkedin.com/in/alicesmith",
    "https://github.com/alicesmith",
    "https://twitter.com/alicesmith",
    ["Independent worker", "Analytical", "Problem solver"],
    ["Java", "Python", "JavaScript"],
    "San Francisco-based software engineer with expertise in Java, Python, and JavaScript. Strongly ranked in education, technical skills, and company fit.",
    80,
    80,
    80,
    80,
    80,
    80
  ),
  new ShortlistCandidate(
    "Bob",
    "Johnson",
    "Data Scientist",
    "Amazon",
    "https://www.amazon.com/",
    "Seattle, WA",
    "150000",
    "https://www.resume.com/bobjohnson",
    "https://www.coverletter.com/bobjohnson",
    "https://www.linkedin.com/in/bobjohnson",
    "https://github.com/bobjohnson",
    "https://twitter.com/bobjohnson",
    ["Collaborative", "Data-driven", "Adaptable"],
    ["R", "SQL", "Python"],
    "Seattle-based data scientist with a 90% match and expertise in R, SQL, and Python. Strongly ranked in education, technical skills, and company fit.",
    90,
    90,
    90,
    90,
    90,
    90
  ),
  new ShortlistCandidate(
    "Carol",
    "Lee",
    "Product Manager",
    "Microsoft",
    "https://www.microsoft.com/",
    "Redmond, WA",
    "140000",
    "https://www.resume.com/carollee",
    "https://www.coverletter.com/carollee",
    "https://www.linkedin.com/in/carollee",
    "https://github.com/carollee",
    "https://twitter.com/carollee",
    ["Leadership", "Negotiation", "Communication"],
    ["Agile", "UX Design", "Data Analysis"],
    "Redmond-based product manager with a strong background in Agile, UX Design, and Data Analysis. Strongly ranked in education, technical skills, and company fit.",
    85,
    85,
    85,
    85,
    85,
    85
  ),
  new ShortlistCandidate(
    "David",
    "Chen",
    "Software Engineer",
    "Facebook",
    "https://www.facebook.com/",
    "Menlo Park, CA",
    "130000",
    "https://www.resume.com/davidchen",
    "https://www.coverletter.com/davidchen",
    "https://www.linkedin.com/in/davidchen",
    "https://github.com/davidchen",
    "https://twitter.com/davidchen",
    ["Creative", "Critical thinking", "Problem solver"],
    ["C++", "Python", "JavaScript"],
    "Menlo Park-based software engineer with expertise in C++, Python, and JavaScript. Strongly ranked in education, technical skills, and company fit.",
    85,
    85,
    85,
    85,
    85,
    85
  ),
  new ShortlistCandidate(
    "Emily",
    "Kim",
    "Data Analyst",
    "Uber",
    "https://www.uber.com/",
    "San Francisco, CA",
    "110000",
    "https://www.resume.com/emilykim",
    "https://www.coverletter.com/emilykim",
    "https://www.linkedin.com/in/emilykim",
    "https://github.com/emilykim",
    "https://twitter.com/emilykim",
    ["Attention to detail", "Data-driven", "Collaborative"],
    ["Excel", "Python", "SQL"],
    "San Francisco-based data analyst with a strong background in Excel, Python, and SQL. Strongly ranked in education, technical skills, and company fit.",
    80,
    80,
    80,
    80,
    80,
    80
  ),
  new ShortlistCandidate(
    "Frank",
    "Liu",
    "UX Designer",
    "Apple",
    "https://www.apple.com/",
    "Cupertino, CA",
    "125000",
    "https://www.resume.com/frankliu",
    "https://www.coverletter.com/frankliu",
    "https://www.linkedin.com/in/frankliu",
    "https://github.com/frankliu",
    "https://twitter.com/frankliu",
    ["Creative", "Attention to detail", "Collaborative"],
    ["User research", "Wireframing", "Prototyping"],
    "Cupertino-based UX designer with expertise in user research, wireframing, and prototyping. Strongly ranked in education, technical skills, and company fit.",
    85,
    85,
    85,
    85,
    85,
    85
  ),
  new ShortlistCandidate(
    "Grace",
    "Wang",
    "Software Engineer",
    "Microsoft",
    "https://www.microsoft.com/",
    "Redmond, WA",
    "115000",
    "https://www.resume.com/gracewang",
    "https://www.coverletter.com/gracewang",
    "https://www.linkedin.com/in/gracewang",
    "https://github.com/gracewang",
    "https://twitter.com/gracewang",
    ["Detail-oriented", "Team player", "Problem solver"],
    ["C#", "JavaScript", "HTML/CSS"],
    "Redmond-based software engineer with expertise in C#, JavaScript, and HTML/CSS. Strongly ranked in education, technical skills, and company fit.",
    80,
    80,
    80,
    80,
    80,
    80
  ),
  new ShortlistCandidate(
    "Henry",
    "Zhang",
    "Data Scientist",
    "Netflix",
    "https://www.netflix.com/",
    "Los Gatos, CA",
    "160000",
    "https://www.resume.com/henryzhang",
    "https://www.coverletter.com/henryzhang",
    "https://www.linkedin.com/in/henryzhang",
    "https://github.com/henryzhang",
    "https://twitter.com/henryzhang",
    ["Collaborative", "Data-driven", "Problem solver"],
    ["Python", "Scala", "Machine learning"],
    "Los Gatos-based data scientist with expertise in Python, Scala, and machine learning. Strongly ranked in education, technical skills, and company fit.",
    90,
    90,
    90,
    90,
    90,
    90
  ),
  new ShortlistCandidate(
    "Isabella",
    "Wu",
    "Product Manager",
    "Amazon",
    "https://www.amazon.com/",
    "Seattle, WA",
    "135000",
    "https://www.resume.com/isabellawu",
    "https://www.coverletter.com/isabellawu",
    "https://www.linkedin.com/in/isabellawu",
    "https://github.com/isabellawu",
    "https://twitter.com/isabellawu",
    ["Strategic thinker", "Collaborative", "Leadership"],
    ["Agile", "Product strategy", "Data analysis"],
    "Seattle-based product manager with a strong background in Agile, product strategy, and data analysis. Strongly ranked in education, technical skills, and company fit.",
    85,
    85,
    85,
    85,
    85,
    85
  ),
  new ShortlistCandidate(
    "Jack",
    "Lin",
    "Frontend Developer",
    "Airbnb",
    "https://www.airbnb.com/",
    "San Francisco, CA",
    "125000",
    "https://www.resume.com/jacklin",
    "https://www.coverletter.com/jacklin",
    "https://www.linkedin.com/in/jacklin",
    "https://github.com/jacklin",
    "https://twitter.com/jacklin",
    ["Creative", "Attention to detail", "Collaborative"],
    ["React", "JavaScript", "HTML/CSS"],
    "San Francisco-based frontend developer with expertise in React, JavaScript, and HTML/CSS. Strongly ranked in education, technical skills, and company fit.",
    80,
    80,
    80,
    80,
    80,
    80
  ),
  new ShortlistCandidate(
    "Karen",
    "Chang",
    "Data Analyst",
    "Google",
    "https://www.google.com/",
    "Mountain View, CA",
    "120000",
    "https://www.resume.com/karenchang",
    "https://www.coverletter.com/karenchang",
    "https://www.linkedin.com/in/karenchang",
    "https://github.com/karenchang",
    "https://twitter.com/karenchang",
    ["Data-driven", "Detail-oriented", "Collaborative"],
    ["Python", "SQL", "Tableau"],
    "Mountain View-based data analyst with expertise in Python, SQL, and Tableau. Strongly ranked in education, technical skills, and company fit.",
    85,
    85,
    85,
    85,
    85,
    85
  ),
  new ShortlistCandidate(
    "Leo",
    "Wang",
    "Full-stack Developer",
    "Facebook",
    "https://www.facebook.com/",
    "Menlo Park, CA",
    "130000",
    "https://www.resume.com/leowang",
    "https://www.coverletter.com/leowang",
    "https://www.linkedin.com/in/leowang",
    "https://github.com/leowang",
    "https://twitter.com/leowang",
    ["Creative", "Problem solver", "Collaborative"],
    ["React", "Node.js", "JavaScript"],
    "Menlo Park-based full-stack developer with expertise in React, Node.js, and JavaScript. Strongly ranked in education, technical skills, and company fit.",
    85,
    85,
    85,
    85,
    85,
    85
  )
]